<template>
  <div :class="classes">
     <pt-page-title title="产科问答列表" :isSearch="true" :searchKey="searchKey"  @search="search" @emptySearch="emptySearch" isParams>
     </pt-page-title>
      <pt-page-factor-filter :labels="filterLabels" v-model="params" :isQueryRouter="true" @Filter="Filter" ref="filter">
        <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <!-- <el-button type="primary">导出</el-button> -->
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
      <pt-obs-department-table :tableLabels="tableLabels" :paramsData="paramsData" :isFromRouter="isFromRouter">
        <el-table-column label="操作">
          <template slot-scope="scope">
          <el-button type="text" @click="getAskDetail(scope.row)">详情</el-button>
          <el-button type="text" @click="getAskEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </pt-obs-department-table>
  </div>
</template>

<script>
// 组件class前缀
import { filterLabels, tableLabels } from './obs-department'
import ptObsDepartmentTable from './pt-obs-department-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-obs-department-question'
export default {
  name: 'pt-obs-department-question',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    allCitys: Array,
    allMembers: Array
  },
  components: {
    ptObsDepartmentTable
  },
  data () {
    return {
      searchKey: null,
      filterLabels: filterLabels,
      tableLabels: tableLabels,
      params: {},
      paramsData: {},
      isFromRouter: false
    }
  },
  watch: {
    allCitys: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'city') {
            item.options = val
          }
        })
      },
      deep: true
    },
    allMembers: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'memberLevelCode') {
            item.options = val
          }
        })
      },
      deep: true
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      this.$set(this.paramsData, 'keyword', val)
    },
    getAskDetail (row) {
      this.$router.push(`/obs-department-detail/${row.id}/false`)
    },
    getAskEdit (row) {
      this.$router.push(`/obs-department-detail/${row.id}/true`)
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'keyword')
      this.$refs.filter.getAddRouter(this.paramsData)
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      let params = JSON.parse(JSON.stringify(this.params))
      for (let key in params) {
        if (!params[key]) {
          this.$delete(params, key)
        }
        if (key === 'doctorAdress') {
          let { cityGbCode, provinceGbCode } = params[key]
          this.paramsData = { ...this.paramsData, cityGbCode, provinceGbCode }
          this.$delete(params, key)
        }
        if (key === 'questionTime' || key === 'exportDate') {
          this.paramsData = { ...this.paramsData, ...params[key] }
          this.$delete(params, key)
        }
      }
      this.paramsData = { ...this.paramsData, ...params }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.Filter()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
